import { colors } from '@flowwai-frontend/shared/style-guide'

export const dataLoadingTheme = {
   light: {
      common: {
         alertTextColor: 'text-gray-800',
         defaultBorderColor: 'border-gray-300'
      },
      dataLoadingHeader: {
         headerBorderColor: 'border-gray-300',
         headerTextColor: 'text-gray-900',
         closeIconColor: colors['gray-500'],
         labelTextColor: 'text-gray-700',
         linkTextColor: 'text-primary-500'
      }
   },
   dark: {}
}
